/**
 * API data loader for client data
 */

import { loadClientDataFallback } from './fallbackDataLoader';

/**
 * Load client data from backend API
 * @returns {Promise<Array>} The loaded client data
 */
export const loadFromAPI = async () => {
  // Always use the Excel fallback for client data, in all environments
  return await loadClientDataFallback();
};
